import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function GoogleAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => { setSession(data); navigate("/", { replace: true }); })
      .catch((e) => navigate("/login", { replace: true, state: { error: e?.response?.data?.detail || "Connexion Google impossible" } }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className="min-h-screen flex items-center justify-center text-sm text-norea-textMuted" data-testid="google-callback">Connexion avec Google…</div>;
}
